// LLM endpoints live on the same backend now — delegate to the shared apiFetch,
// preserving the error contract callers branch on:
// NOT_AUTHENTICATED | UNAUTHORIZED | API_UNREACHABLE | API_ERROR (err.code).
import { apiFetch } from "../api/client";

// The backend gives AI runs up to 180 s and these calls routinely take 5–20 s — the 15 s default would cut them off.
export const LLM_TIMEOUT_MS = 90_000;

export const llmApiPost = (path, body) =>
  apiFetch(path, { method: "POST", body, timeoutMs: LLM_TIMEOUT_MS });
